import { useCallback, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import styles from "./UpgradeModal.module.css";
import { REPORT_TYPE_LABEL } from "../constants/reportAccess";

export default function UpgradeModal({ reportType, onClose }) {
  const navigate = useNavigate();
  const [closing, setClosing] = useState(false);

  const reportLabel = REPORT_TYPE_LABEL[reportType] ?? reportType ?? "this report";

  const handleClose = useCallback(() => {
    setClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 200);
  }, [onClose]);

  const handleUpgrade = useCallback(() => {
    onClose?.();
    navigate("/billing");
  }, [navigate, onClose]);

  const modalNode = (
    <div
      className={`${styles.overlay} ${closing ? styles.overlayOut : ""}`}
      onClick={handleClose}
    >
      <div
        className={`${styles.modal} ${closing ? styles.modalOut : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles.closeBtn} onClick={handleClose} aria-label="Close">
          ✕
        </button>

        <div className={styles.eyebrow}>Monthly Plan</div>
        {/* <div className={styles.icon}>🔒</div> */}

        <h2 className={styles.title}>Unlock {reportLabel}</h2>
        <p className={styles.body}>
          This report is part of the <strong>Monthly Subscription</strong>.
          Upgrade for <strong>$49/month</strong> to unlock all reports, Zeqi
          Chat, and full historical access for your shop.
        </p>

        <ul className={styles.featureList}>
          <li>All report types unlocked</li>
          <li>Full historical data access</li>
          <li>Zeqi Chat and AI-powered recommendations</li>
          <li>Cancel anytime</li>
        </ul>

        <div className={styles.actions}>
          <button className={styles.upgradeBtn} onClick={handleUpgrade}>
            Go to Billing
          </button>
          <button className={styles.cancelBtn} onClick={handleClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return modalNode;
  }

  return createPortal(modalNode, document.body);
}
